export default "__VITE_ASSET__9bb9e752__"